import SvgIcon from '@/pages/home/components/SvgIcon';
import React, { useEffect, useState } from 'react';
import { SelectMultiple, Bubble } from 'tea-component';
import './index.scss';
import { languageSelectMap, languageSelectOptions } from '../../constant';
import { useIntl } from 'umi';
import { isEqual } from 'lodash-es';
import { CONTACT_EMAIL } from '@op/constants';

// 定义 Props 接口
interface ITranslateSelectProps {
  onChange?: (key: string, value: string[]) => void;
  key?: string;
  style?: React.CSSProperties;
  defaultValue?: string[];
  defaultParams: {
    value: string[];
  };
  hideIcon?: boolean;
  defaultValueText?: string;
  chineseDisabled?: boolean;
}

const TranslateSelect = (props: ITranslateSelectProps) => {
  const { formatMessage } = useIntl();
  const {
    onChange,
    key,
    style,
    defaultValue,
    defaultParams: { value },
    hideIcon = false,
    defaultValueText = '',
    chineseDisabled = false,
  } = props;
  const [languageChoose, setLanguageChoose] = useState(
    defaultValue || ['origin'],
  );

  const languageButton = (): JSX.Element => {
    let text = languageChoose
      ?.map((key: string | number) =>
        formatMessage({ id: languageSelectMap[key] }),
      )
      ?.join(', ');
    if (defaultValueText && isEqual(defaultValue, value)) {
      text = defaultValueText;
    }
    return (
      <div className="dbo-select-button">
        {!hideIcon && (
          <SvgIcon type="translate" className="dbo-select-button-icon" />
        )}
        <div className="tea-text-overflow">{text}</div>
      </div>
    );
  };

  const disableMemo = (value: string): boolean => {
    if (chineseDisabled && value === 'zh') return true;

    return (
      languageChoose &&
      languageChoose.length === 1 &&
      languageChoose.includes(value)
    );
  };

  useEffect(() => {
    setLanguageChoose(value || ['origin']);
  }, [value]);

  return (
    <SelectMultiple
      className={`select-item dbo-translate-select ${hideIcon ? 'dbo-translate-select-link' : ''
        }`}
      staging={false}
      size="m"
      boxClassName="select-translate-box-wrapper"
      appearance={hideIcon ? 'default' : 'button'}
      matchButtonWidth={!hideIcon}
      value={languageChoose || []}
      onChange={(value) => {
        setLanguageChoose(value || []);
        onChange?.(key!, value);
      }}
      options={languageSelectOptions.map((item) => {
        let disabledText: string | null = null;

        if (disableMemo(item.value)) {
          disabledText = 'Please reserve one option';

          if (item.value === 'zh') {
            disabledText =
              `The current game has low priority, and the original text is unavailable in Chinese translation. For any inquiries, please contact {email}.`;
          }
        }

        return {
          ...item,
          text: (
            <div key={item.value}>
              <Bubble
                closeOnScroll
                placement="right"
                dark
                content={disabledText && formatMessage({ id: disabledText }, { email: CONTACT_EMAIL })}
              >
                {formatMessage({ id: item.text })}
              </Bubble>
            </div>
          ),
          disabled: disableMemo(item.value),
        };
      })}
      button={languageButton}
      footer={
        <div style={{ textAlign: 'left', maxWidth: 204 }}>
          {formatMessage({
            id: 'From GPT-Translator. Powered by DataBrain NLP Team',
          })}
        </div>
      }
      style={{ ...(style || {}) }}
    />
  );
};

export default TranslateSelect;
